module.exports = __webpack_public_path__ + "static/media/sort.a9cf2b4f.svg";